<template>
  <div class="create-invoice__popup">
    <div class="create-invoice__popup-title">{{i18n.cont_create_invoice()}}</div>
    <form novalidate class="create-invoice__form">
      <div class="create-invoice__row">
        <select-field class="create-invoice__field"
                      v-if="invoiceAsset"
                      :value="invoiceAsset"
                      :values="Object.keys(accountBalances)"
                      @input="$emit(events.assetChange, $event)"
        />
        <input-field class="create-invoice__field"
                     :label="i18n.cont_invoice_number()"
                     v-validate="'required'"
                     name="invoice-number"
                     v-model="form.number" />
        <input-field class="create-invoice__field"
                     :label="i18n.cont_invoice_amount({ asset: invoiceAsset})"
                     v-validate="'required'"
                     name="invoice-amount"
                     v-model="form.amount" />
      </div>
      <div class="create-invoice__row">
        <div class="create-invoice__field-bottom">
          <h3 class="create-invoice__field-title">{{i18n.lbl_document()}}</h3>
          <file-field fileType="image"
                      v-validate="'required'"
                      name="invoice-file"
                      :type="documentTypes.invoice"
                      v-model="documents.invoice"/>
        </div>
        <div class="create-invoice__field-bottom">
          <h3 class="create-invoice__field-title">{{i18n.lbl_note()}}</h3>
          <textarea-field v-model="form.note"
                          name="invoice-note"
                          v-validate="'required'" />
        </div>

      </div>
      <div class="create-invoice__submit-wrapper">
        <md-button @click="submit"
                    class="md-primary"
                    :disabled="isPending"
        >{{ i18n.lbl_submit() }}</md-button>
      </div>
    </form>
  </div>
</template>

<script>
import FormMixin from '@com/mixins/form.mixin'
import FileField from '@com/fields/FileField'
import SelectField from '@com/fields/SelectField'

import { mapActions, mapGetters } from 'vuex'
import { i18n } from '@js/i18n'
import { documentTypes } from '@const'
import { vuexTypes } from '@vuex/types'
import { contractsService } from '@api/contracts.service'
import { fileService } from '@api/file.service'
import { EventDispatcher } from '@js/events/event_dispatcher'
import { ErrorHandler } from '@js/errors/error_handler'
import { commonEvents } from '@js/events/common_events'
import {errors} from '@js/errors/factory'

export default {
  components: { FileField, SelectField },
  props: ['contractId', 'customerId', 'invoiceAsset'],
  mixins: [FormMixin],
  data: _ => ({
    i18n,
    events: {
      assetChange: commonEvents.assetChangeEvent
    },
    documentTypes,
    isLoading: false,
    form: {
      number: '',
      amount: '',
      note: ''
    },
    documents: {
      invoice: null
    }
  }),
  methods: {
    ...mapActions({
      loadInvoices: vuexTypes.GET_USER_INVOICES_REQUESTS,
      updateTwoFactorData: vuexTypes.SET_TWO_FACTOR_STATE
    }),
    async submit () {
      if (!await this.isValid()) return
      this.disable()

      try {
        const invoiceFile = this.documents.invoice
        if (invoiceFile && !invoiceFile.isUploaded) {
          const invoiceFileKey = await fileService.uploadFile(invoiceFile.getDetailsForUpload())
          invoiceFile.setKey(invoiceFileKey)
        }
        const details = {
          invoice_number: this.form.number,
          invoice_file: invoiceFile.getDetailsForSave(),
          note: this.form.note
        }
        await contractsService.createInvoiceRequest({
          sender: this.customerId,
          contractID: this.contractId,
          asset: this.invoiceAsset,
          amount: this.form.amount,
          details: details
        })
        this.$emit('close-request')
        EventDispatcher.dispatchShowSuccessEvent(i18n.cont_invoice_created())
        await this.loadInvoices(this.contractId)
      } catch (error) {
        if (error instanceof errors.TFAExceededCodeError) {
          EventDispatcher.dispatchShowErrorEvent(i18n.tfa_to_many_attempts())
        } else {
          ErrorHandler.processUnexpected(error)
        }
      }

      this.enable()
    }
  },
  computed: {
    ...mapGetters([
      vuexTypes.accountBalances,
      vuexTypes.factorData
    ])
  }
}
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .create-invoice__popup-title {
    line-height: 1.625rem;
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }

  .create-invoice__form {
    display: flex;
    flex-direction: column;
  }

  .create-invoice__row {
    display: flex;
    justify-content: space-between;
  }

  .create-invoice__field {
    width: 30%;

    &-bottom {
      width: 49%;
    }
  }

  .create-invoice__submit-wrapper {
    text-align: right;
    margin-right: -1.5rem;
  }

  .create-invoice__field-title {
    margin-bottom: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/modals/Contracts.CreateInvoice.vue